let cookieName = 'menu_collapsed';

// neschovávat sidebar, když je aktivní výběr fakulty
let fakulta_vyber_click=(event)=> {
    if ((event.type==='click')&&(event.target.closest('.dropdown.faculty-selector'))) {
        setTimeout(function(){
            var sidebar=event.target.closest('.vut-sidebar.vut-sidebar-collapsed');
            if (sidebar) {
                sidebar.classList[document.querySelector('.dropdown.faculty-selector.open')?'add':'remove']('vut-sidebar-collapsed-vyber-fakulty');
            }
        }, 25);
    } else {
        var e;
        while (e=document.querySelector('.vut-sidebar.vut-sidebar-collapsed.vut-sidebar-collapsed-vyber-fakulty')) {
            e.classList.remove('vut-sidebar-collapsed-vyber-fakulty');
        }
    }
}

let sidebar=(event)=> {
    fakulta_vyber_click(event);
    let button = event.target.closest?.('.menu-lock');
    if (button) {
        let r = new RegExp('^' + cookieName + '=');
        let cookie = parseInt((document.cookie.split(';').map(c => c.trim()).find((c) => r.test(c)))?.split('=')?.[1] ?? 0) || 0;

        document.cookie = cookieName + '=' + (cookie ? 0 : 1) + '; expires=' + (new Date(new Date().getTime() + 5184000000).toUTCString()) +'; path=/';

        document.querySelectorAll('.vut-sidebar').forEach(e=>e.classList[cookie?'remove':'add']('vut-sidebar-collapsed'));
        document.querySelectorAll('.vut-sidebar-wrap').forEach(e=>e.classList[cookie?'remove':'add']('vut-sidebar-wrap-collapsed'));

        button.dataset.originalTitle = cookie ? jstr('Skrývat menu') : jstr('Neskrývat menu');

        let icon = button.querySelector('.icon-indent-increase2,.icon-indent-decrease2')

        icon?.classList?.[cookie?'remove':'add']('icon-indent-increase2');
        icon?.classList?.[!cookie?'remove':'add']('icon-indent-decrease2');

        window.$?.(button)?.tooltip?.('hide');

        VUTResizeHandler.dispatch();

    }
}

var prevent_mobile_click=function(event){
    if (event.target.closest('.vut-sidebar a')) {
        if(
            document.querySelector(".vut-sidebar")
            &&(document.querySelector(".vut-sidebar").offsetWidth<48)
        ) {
            document.querySelector(".vut-sidebar").classList.add("vut-sidebar-a-prevent");
            setTimeout(function(){document.querySelector(".vut-sidebar").classList.remove("vut-sidebar-a-prevent");}, 500);
        }
        // hybrid hack //
        document.querySelector(".vut-sidebar").classList.add("vut-sidebar-touched");
    } else if (!event.target.closest('.vut-sidebar')){
        document.querySelector(".vut-sidebar").classList.remove("vut-sidebar-touched");
    }
}

let init=()=>{
    if (!document.querySelector('.menu-lock')) return;
    cookieName = document.querySelector('.menu-lock')?.dataset?.cookieName || cookieName;
    window.addEventListener('click', sidebar, true);

    // zabránit kliku na položku schovaného sidebaru při touch na mobilu //
    window.addEventListener("touchstart", function(event){
        document.querySelector("#menu-hledani").blur();
        prevent_mobile_click(event);
        // apple hack -- odvolání hoveru -- i při aktivním hledání + schování lišty pokud je zamklá dropdownem...
        fakulta_vyber_click(event);
    }, true);

    // vyvolání resize při rozbalení/zabalení menu na mobilu //
    let i, t;
    window.addEventListener('transitionstart', (event)=>{
        if (event.target.matches('.collapsing')) {
            clearInterval(i);
            // nejde dát míň, 50 je timeout v handleru //
            i=setInterval(window.VUTResizeHandler?.dispatch, 55);
            // záchranná brzda, kdyby se transitionend nějak nepovedl, už se to povedlo...
            clearTimeout(t);
            t=setTimeout(clearInterval.bind(window, i), 750);
        }
    });
    window.addEventListener('transitionend', (event)=>{
        if (event.target.matches('.collapse')) {
            window.VUTResizeHandler?.dispatch?.()
            clearInterval(i)
            clearTimeout(t);
        }
    });

}

window.addEventListener('DOMContentLoaded', init, true);